(function () {
  var d = document.documentElement;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  d.classList.add('ab-anim');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  function scan() {
    document.querySelectorAll('[data-ab-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
    document.querySelectorAll('.ab-salon:not([data-ab-light])').forEach(function (s) {
      s.setAttribute('data-ab-light', '');
      s.addEventListener('pointermove', function (ev) {
        var r = s.getBoundingClientRect();
        s.style.setProperty('--x', (ev.clientX - r.left) + 'px');
        s.style.setProperty('--y', (ev.clientY - r.top) + 'px');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  setTimeout(function () { document.querySelectorAll('[data-ab-reveal]:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); }); }, 1500);
})();

/* Warenkorb-Upsell: 1-Klick hinzufügen (optional mit Menge + Eigenschaften), Drawer aktualisiert sich über das Theme-Event */
document.addEventListener('click', async function (e) {
  var btn = e.target.closest && e.target.closest('[data-ab-add]');
  if (!btn) return;
  e.preventDefault();
  if (btn.disabled) return;
  btn.disabled = true; btn.textContent = '…';
  var id = btn.getAttribute('data-ab-add');
  var qty = Number(btn.getAttribute('data-ab-qty')) || 1;
  var props = null;
  try { props = btn.getAttribute('data-ab-props') ? JSON.parse(btn.getAttribute('data-ab-props')) : null; } catch (_) { props = null; }
  var item = { id: Number(id), quantity: qty };
  if (props) item.properties = props;
  var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean);
  var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
  var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  try {
    var ev = await import('@shopify/events');
    var dfd = ev.CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity: qty }], promise: dfd.promise }));
    var res = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item], sections: ids.join(',') }) }).then(function (r) { return r.json(); });
    var cart = await fetch(cartUrl + '.json', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    dfd.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'ab-upsell', itemCount: qty, sections: res.sections, didError: !!res.status } });
    if (!document.querySelector('cart-drawer-component')) location.reload();
  } catch (err) {
    await fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
    location.reload();
  }
});

/* v5.1 – Handy: lange Produktbeschreibung einklappen, Kaufbereich bleibt nah */
(function () {
  function fold() {
    if (!matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.product-details rte-formatter.rte:not([data-ab-fold])').forEach(function (el) {
      el.setAttribute('data-ab-fold', '');
      if (el.scrollHeight < 420) return;
      el.classList.add('ab-collapsed');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ab-more-btn'; b.textContent = 'Mehr über das Werk';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = el.classList.toggle('ab-collapsed') === false;
        b.textContent = open ? 'Weniger anzeigen' : 'Mehr über das Werk';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      el.insertAdjacentElement('afterend', b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fold); else fold();
})();
